import { useSelector } from 'react-redux'
import { useState } from 'react'

import { usePageTitle } from '@h2/common/components/hooks/usePageTitle'

import { loadSubsequentSearchResults, search } from '../actions/search'
import SearchQueryHandlerComponent from '../components/search/SearchQueryHandlerComponent'
import { useQuery } from '../util/hooks'

const Search = props => {
  const [filterModel, setFilterModel] = useState({})
  const pageTitle = null
  const queryTerm = useQuery().q
  const loadFunction = search(queryTerm)
  const loadMoreFunction = loadSubsequentSearchResults(queryTerm, filterModel)
  const searchRequest = useSelector(state => state.search.searchRequest)

  usePageTitle('Site Search')

  return (
    <SearchQueryHandlerComponent
      loadFunction={loadFunction}
      loadMoreFunction={loadMoreFunction}
      setFilterModel={setFilterModel}
      pageTitle={pageTitle}
      searchRequest={searchRequest}
      {...props}
    />
  )
}

export default Search
